module.exports = __webpack_public_path__ + "img/柚子2.99927769.png";